import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-bootstrap/Modal';
import InputAuto from '../../helpers/input-auto';
import ReactLoading from 'react-loading';
import { catchError } from '../../helpers/catch-error'
import { validateEmail, validatePhone } from '../../helpers/common';

const PatientInformation = ({ work_order, onWorkOrderChange, onWorkOrderCreated, is_loading = true }) => {
  const navigate = useNavigate();
  const location = useLocation()
  const [patient, setPatient] = useState({
    patient_id: "",
    patient_first_name: "",
    patient_middle_name: "",
    patient_last_name: "",
    patient_dob: "",
    patient_ssn: "",
    patient_med_rec_num: "",
    patient_phone_number: "",
    patient_email: "",
    patient_address: "",
  });
  const [patientAdd, setPatientAdd] = useState({
    patient_id: "",
    patient_first_name: "",
    patient_middle_name: "",
    patient_last_name: "",
    patient_dob: "",
    patient_ssn: "",
    patient_med_rec_num: "",
    patient_phone_number: "",
    patient_email: "",
    patient_address: "",
  });
  const [patientMask, setPatientMask] = useState(true);
  const [WOPatientAuthorization, setWOPatientAuthorization] = useState(null);
  const [WOPatientSpecialAuthorization, setWOPatientSpecialAuthorization] = useState(null);
  const [patientsFirstNames, setPatientsFirstNames] = useState([])
  const [patientsMiddleNames, setPatientsMiddleNames] = useState([])
  const [patientsLastNames, setPatientsLastNames] = useState([])
  const [isBtn, setIsBtn] = useState(false)
  const [inputError, setInputError] = useState(false);
  const [patientSearch, setPatientSearch] = useState({
    patient_first_name: "",
    patient_middle_name: "",
    patient_last_name: "",
    patient_dob: "",
    patient_ssn: "",
    patient_med_rec_num: "",
    client_company_name: "",
    facility_name: "",
    client_company_name: "",
  });
  const [isSearchPatientModalOpen, setIsSearchPatientModalOpen] = useState(false);
  const [searchResults, setSearchResults] = useState(null);
  const [advanceSearchResults, setAdvanceSearchResults] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [addMode, setAddMode] = useState(false);

  useEffect(() => {

    getPatientsFirstNames();
    getPatientsMiddleNames();
    getPatientsLastNames();
    /*  alert(work_order?.patient_id);
    if (work_order?.patient_id > 0) {
      getPatient(work_order?.patient_id);
    }
*/
  }, []);



  useEffect(() => {


    // alert(work_order?.patient_id);
    if (work_order?.patient_id > 0) {
      getPatient(work_order?.patient_id);
    }

  }, [work_order?.patient_id]);

  useEffect(() => {

    if (work_order?.work_order_id > 0)
      navigate(`/admin/work-order/` + work_order?.work_order_id);

  }, [work_order?.work_order_id]);


  const getPatientsFirstNames = async (e) => {


    axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-patients-first-names", {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {

      if (response?.data?.status) {

        setPatientsFirstNames(response?.data?.patients);

      } else {

        Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });

      }
    }).catch(function (error) {

      catchError(error, navigate)

    });

  }


  const getPatientsMiddleNames = async (e) => {


    axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-patients-middle-names", {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {

      if (response?.data?.status) {

        setPatientsMiddleNames(response?.data?.patients);

      } else {

        Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });

      }
    }).catch(function (error) {

      catchError(error, navigate)

    });

  }

  const getPatientsLastNames = async (e) => {


    axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-patients-last-names", {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {

      if (response?.data?.status) {

        setPatientsLastNames(response?.data?.patients);

      } else {

        Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });

      }
    }).catch(function (error) {

      catchError(error, navigate)

    });

  }


  const getPatient = async (patient_id) => {


    axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-patient-by-id/" + patient_id, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {

      if (response?.data?.status) {

        let p = response?.data?.patient;
        p.patient_dob = p.patient_dob_formatted

        if (p.patient_address && p.patient_address != "") {
          p.patient_secondary_info = "Address"
        }
        else if (p.patient_phone_number && p.patient_phone_number != "") {
          p.patient_secondary_info = "Phone"
        }
        else {
          p.patient_secondary_info = "Email"
        }
        setPatient(p);
        setIsSearchPatientModalOpen(false);

      } else {

        Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });

      }
    }).catch(function (error) {

      catchError(error, navigate)

    });

  }


  const addPatientToWorkOrder = async (patient, auth = false) => {

    setSearchResults(null);
    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/save-patient-to-work-order",
      {
        work_order_id: work_order?.work_order_id, patient_id: patient.patient_id
      },
      {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      }).then(async function (response) {

        if (response?.data?.status) {


          if (!work_order?.work_order_id) {

            onWorkOrderChange(response?.data?.workOrder);
          }
          setIsSearchPatientModalOpen(false)
          // alert(`/${response?.data?.workOrder.work_order_id}/`);


          if (auth) {

            addWOPatientAuthorizationToWorkOrder(response?.data?.workOrder?.work_order_id);

          }





        } else {
          Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });
          setIsBtn(false)
        }

      }).catch(function (error) {

        catchError(error, navigate)

      });




  }

  const addWOPatientAuthorizationToWorkOrder = async (work_order_id, type = 0) => {

    setIsBtn(true);
    let auth = {
      work_order_id: work_order_id,
      type: type
    }
    if (type == 0 || type == 1) {
      auth.wo_patient_authorization = WOPatientAuthorization;
    }
    if (type == 0 || type == 2) {
      auth.wo_patient_special_authorization = WOPatientSpecialAuthorization;
    }


    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/save-patient-authorization-to-work-order", auth, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true
    }).then(function (response) {

      if (response?.data?.status) {

        if (!response?.data?.wo_patient_authorization && !response?.data?.wo_patient_special_authorization) {

          Swal.fire({ icon: "error", title: "Patient Authorization Failed to Upload", text: "Please ensure that your file is in PDF format and that its size is less than 30MB." });

        }

        else if (type == 0) {
          onWorkOrderChange({ wo_patient_authorization: response?.data?.wo_patient_authorization, authorization_status: 1, wo_patient_special_authorization: response?.data?.wo_patient_special_authorization });

        }
        else if (type == 1 && response?.data?.wo_patient_authorization) {
          onWorkOrderChange({ wo_patient_authorization: response?.data?.wo_patient_authorization, authorization_status: 1 });
        }

        if (type == 2 && response?.data?.wo_patient_special_authorization) {
          onWorkOrderChange({ wo_patient_special_authorization: response?.data?.wo_patient_special_authorization });
        }

        setWOPatientAuthorization(null);
        setWOPatientSpecialAuthorization(null);
        setIsBtn(false);


      } else {

        Swal.fire({ icon: "error", title: "Patient Authorization Upload Error", text: "Please ensure that your file is in PDF format and that its size is less than 30MB. Please try again" });

      }
    }).catch(function (error) {

      catchError(error, navigate)

    });


  }


  const resetPatientAdd = async (e) => {
    setPatientAdd({
      patient_id: "",
      patient_first_name: "",
      patient_middle_name: "",
      patient_last_name: "",
      patient_dob: "",
      patient_ssn: "000-00-0000",
      patient_med_rec_num: "",
      patient_secondary_info: "Email",
      patient_phone_number: "",
      patient_email: "",
      patient_address: "",
    });
  }

  const savePatient = async (e) => {

    setIsBtn(true);
    let error_flag = false;

   // const patient_email = patientAdd?.patient_secondary_info == "Email" ? patientAdd.patient_email : "";
   // const patient_phone_number = patientAdd?.patient_secondary_info == "Phone" ? patientAdd.patient_phone_number : "";
    const { patient_first_name, patient_middle_name, patient_last_name, patient_dob, patient_ssn ,patient_email,patient_phone_number} = patientAdd;
    if (!patient_first_name || !patient_last_name || !patient_dob || !patient_ssn ||
      !(patient_first_name.match(/^[A-Za-z'.\-, ]+$/)) || (patient_middle_name && !patient_middle_name.match(/^[A-Za-z'.\-, ]+$/))  || !(patient_last_name.match(/^[A-Za-z'.\-, ]+$/)) ||
      !/^\d{2}\/\d{2}\/\d{4}$/.test(patient_dob) || !/^\d{3}-\d{2}-\d{4}$/.test(patient_ssn) || !validateEmail(patient_email) || !validatePhone(patient_phone_number)) {

      error_flag = true;
    }

    if (error_flag) {

      setInputError(true);
      setIsBtn(false);

    } else {

      var patient_info = {
        patient_first_name: patientAdd.patient_first_name,
        patient_middle_name: patientAdd.patient_middle_name,
        patient_last_name: patientAdd.patient_last_name,
        patient_dob: patientAdd.patient_dob,
        patient_ssn: patientAdd.patient_ssn,
        patient_med_rec_num: patientAdd.patient_med_rec_num,
        patient_address: patientAdd.patient_address ,
        patient_phone_number: patient_phone_number,
        patient_email: patient_email,

      }
      axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/save-patient", patient_info, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      }).then(async function (response) {

        if (response?.data?.status) {

          getPatient(response?.data?.patient_id);
          setEditMode(false);
          setAddMode(false);
          addPatientToWorkOrder({ patient_id: response?.data?.patient_id }, false);
          setIsBtn(false);

        } else {
          Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });
          setIsBtn(false)
        }
      }).catch(function (error) {

        catchError(error, navigate)

      });

    }
  }


  const updatePatient = async (e) => {

    setIsBtn(true);
    let error_flag = false;

  //  const patient_email = patient?.patient_secondary_info == "Email" ? patient.patient_email : "";
  //  const patient_phone_number = patient?.patient_secondary_info == "Phone" ? patient.patient_phone_number : "";
    const { patient_first_name, patient_middle_name, patient_last_name, patient_dob, patient_ssn,patient_email, patient_phone_number} = patient;
    if (!patient_first_name || !patient_last_name || !patient_dob || !patient_ssn ||
      !(patient_first_name.match(/^[A-Za-z'.\-, ]+$/)) || (patient_middle_name && !patient_middle_name.match(/^[A-Za-z'.\-, ]+$/))  || !(patient_last_name.match(/^[A-Za-z'.\-, ]+$/)) ||
      !/^\d{2}\/\d{2}\/\d{4}$/.test(patient_dob) || !/^\d{3}-\d{2}-\d{4}$/.test(patient_ssn) || !validateEmail(patient_email) || !validatePhone(patient_phone_number)) {

      error_flag = true;
    }

    if (error_flag) {

      setInputError(true);
      setIsBtn(false);

    } else {

      var patient_info = {
        patient_id: patient.patient_id,
        patient_first_name: patient.patient_first_name,
        patient_middle_name: patient.patient_middle_name,
        patient_last_name: patient.patient_last_name,
        patient_dob: patient.patient_dob,
        patient_ssn: patient.patient_ssn,
        patient_med_rec_num: patient.patient_med_rec_num,
        patient_address:patient.patient_address ,
        patient_phone_number: patient_phone_number,
        patient_email: patient_email,


      }
      axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-patient", patient_info, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      }).then(async function (response) {

        if (response?.data?.status) {

          getPatient(patient.patient_id);
          setEditMode(false);
          setAddMode(false);

        } else {
          Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });

        }
        setIsBtn(false)

      }).catch(function (error) {

        setIsBtn(false);
        catchError(error, navigate)

      });

    }


  }


  const removeAuthorization = async (e) => {


    setIsBtn(true);
    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-patient-authorization",
      {
        work_order_id: work_order?.work_order_id
      },
      {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      }).then(function (response) {

        if (response?.data?.status) {

          setWOPatientAuthorization(null);
          onWorkOrderChange({ authorization_status: 0, wo_patient_authorization: null });


        } else {
          Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });
        }
        setIsBtn(false)


      }).catch(function (error) {
        catchError(error, navigate)

      });



  }



  const invalidateAuthorization = async (e) => {

    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/invalidate-patient-authorization",
      {
        work_order_id: work_order?.work_order_id
      },
      {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      }).then(function (response) {

        if (response?.data?.status) {

          onWorkOrderChange({ authorization_status: 0 });


        } else {

          Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });
          setIsBtn(false)
        }

      }).catch(function (error) {
        catchError(error, navigate)

      });



  }



  const validateAuthorization = async (e) => {


    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/validate-patient-authorization",
      {
        work_order_id: work_order?.work_order_id
      },
      {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      }).then(function (response) {

        if (response?.data?.status) {

          onWorkOrderChange({ authorization_status: 1 });


        } else {
          Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });
          setIsBtn(false)
        }

      }).catch(function (error) {
        catchError(error, navigate)

      });



  }




  const removeSpecialAuthorization = async (e) => {


    setIsBtn(true);
    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-patient-special-authorization",
      {
        work_order_id: work_order?.work_order_id
      },
      {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      }).then(function (response) {

        if (response?.data?.status) {

          setWOPatientSpecialAuthorization(null);
          onWorkOrderChange({ wo_patient_special_authorization: null });


        } else {
          Swal.fire({ icon: "error", title: "Patient Info", text: response?.data?.message });
        }
        setIsBtn(false)


      }).catch(function (error) {
        catchError(error, navigate)

      });



  }



  const searchPatient = (first_name = "", middle_name = "", last_name = "", limit = 20) => {

    var search_elements = {}
    if (first_name != "") {
      search_elements.patient_first_name = first_name;
    }
    else if (middle_name != "") {
      search_elements.patient_middle_name = middle_name;
    }
    else if (last_name != "") {
      search_elements.patient_last_name = last_name;
    }
    else {
      search_elements.patient_first_name = patient.patient_first_name;
      search_elements.patient_middle_name = patient.patient_middle_name;
      search_elements.patient_last_name = patient.patient_last_name;
      search_elements.patient_dob = patient.patient_dob;
      search_elements.patient_ssn = patient.patient_ssn;
      search_elements.patient_med_rec_num = patient.patient_med_rec_num;
      search_elements.patient_address = patient.patient_address;
      search_elements.patient_phone_number = patient.patient_phone_number;
      search_elements.patient_email = patient.patient_email;

    }
    search_elements.limit = limit;

    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/search-patients", search_elements, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {


      if (response?.data?.status) {

        let searched_patients = null;
        if (response?.data?.patients?.length > 0) {
          searched_patients = (
            <>

              <ul className="search-results-ul">
                {response?.data?.patients?.map((p) => (
                  <li key={p.id} onClick={() => addPatientToWorkOrder(p)} ><a className="btn btn-sm btn-link">{p.link}</a></li>
                ))}
              </ul>
            </>
          );
        }
        setSearchResults(searched_patients);

      }
      else {
        setSearchResults(null);

      }

    }).catch(function (error) {

      // setIsBtn(false);
      catchError(error, navigate)

    });


  }




  const scanPatient = (limit = 20) => {

    var search_elements = {}
    search_elements.patient_first_name = patientAdd?.patient_first_name;
    search_elements.patient_middle_name = patientAdd?.patient_middle_name;
    search_elements.patient_last_name = patientAdd?.patient_last_name;
    search_elements.patient_dob = patientAdd?.patient_dob;
    if (patientAdd?.patient_ssn != "000-00-0000")
      search_elements.patient_ssn = patientAdd?.patient_ssn;
    search_elements.patient_med_rec_num = patientAdd?.patient_med_rec_num;
    search_elements.patient_address = patientAdd?.patient_address;
    search_elements.patient_phone_number = patientAdd?.patient_phone_number;
    search_elements.patient_email = patientAdd?.patient_email;


    search_elements.limit = limit;

    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/search-patients", search_elements, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {


      if (response?.data?.status) {

        let searched_patients = null;
        if (response?.data?.patients?.length > 0) {
          searched_patients = (
            <>

              <ul className="search-results-ul">
                {response?.data?.patients?.map((p) => (
                  <li key={p.id} onClick={() => addPatientToWorkOrder(p)} ><a className="btn btn-sm btn-link">{p.link}</a></li>
                ))}
              </ul>
            </>
          );
        }
        setSearchResults(searched_patients);

      }
      else {
        setSearchResults(null);

      }

    }).catch(function (error) {

      // setIsBtn(false);
      catchError(error, navigate)

    });


  }




  const advanceSearchPatient = (first_name = "", middle_name = "", last_name = "") => {

    setIsBtn(true);
    var search_elements = {}
    if (first_name != "") {
      search_elements.patient_first_name = first_name;
    }
    else if (middle_name != "") {
      search_elements.patient_middle_name = middle_name;
    }
    else if (last_name != "") {
      search_elements.patient_last_name = last_name;
    }
    else {
      search_elements.patient_first_name = patientSearch.patient_first_name;
      search_elements.patient_middle_name = patientSearch.patient_middle_name;
      search_elements.patient_last_name = patientSearch.patient_last_name;
      search_elements.patient_dob = patientSearch.patient_dob;
      search_elements.patient_ssn = patientSearch.patient_ssn;
      search_elements.patient_med_rec_num = patientSearch.patient_med_rec_num;
      search_elements.client_company_name = patientSearch.client_company_name;
      search_elements.facility_name = patientSearch.facility_name;
      search_elements.wo_policy_number = patientSearch.wo_policy_number;
      search_elements.limit = 20;
    }

    axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/search-patients", search_elements, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(function (response) {


      if (response?.data?.status) {

        let searched_patients = "";

        if (response?.data?.patients?.length > 0) {
          searched_patients = (
            <>

              <ul className="search-results-ul">
                {response?.data?.patients?.map((p) => (
                  <li key={p.id} onClick={() => addPatientToWorkOrder(p)} ><a className="btn btn-sm btn-link">{p.link}</a></li>
                ))}
              </ul>
            </>
          );
        }
        setAdvanceSearchResults(searched_patients);

      }
      else {
        setAdvanceSearchResults(null);

      }
      setIsBtn(false);
    }).catch(function (error) {

      setIsBtn(false);
      catchError(error, navigate)

    });


  }


  const resetSearchPatient = () => {

    setPatientSearch({
      patient_first_name: "",
      patient_middle_name: "",
      patient_last_name: "",
      patient_dob: "",
      patient_ssn: "",
      patient_med_rec_num: "",
      patient_phone_number: "",
      patient_email: "",
      patient_address: "",
    });

  }



  const togglePatientMask = () => {

    if (patientMask) {
      setPatientMask(false);
    }
    else {
      setPatientMask(true);

    }

  }


  return (
    <>



      <div className="card card-form  h-100 " >
        <div className="card-body p-0" >
          <div className=" card-heading row m-0" >
            <div className="col-md-5 col-sm-12 py-2 ps-3">
              <h6 className=" fw-bold text-dark mt-2">PATIENT INFORMATION</h6>
            </div>

            {(!work_order || work_order?.status < 7) &&
              <div className="col-md-7 col-sm-12 text-md-end -2 my-2">


                {addMode ?
                  <>
                    <button onClick={() => savePatient()} className="btn btn-sm  btn-success me-1 my-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1 my-1" role="status"></div><span className="sr-only">Loading...</span></> : "SAVE"}</button>
                    <button onClick={() => { setAddMode(false); resetPatientAdd(); }} className="btn btn-sm  btn-warning me-1 my-1 " type="button">CANCEL SAVE</button>
                    <button onClick={() => scanPatient(5)} className="btn btn-sm btn-danger mx-1" type="button">SCAN </button>
                  </>
                  :
                  <>
                    {editMode ?
                      <>
                        <button onClick={() => updatePatient()} className="btn btn-sm  btn-success me-1 my-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1 my-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPDATE"}</button>
                        <button onClick={() => setEditMode(false)} className="btn btn-sm   btn-warning me-1 my-1 " type="button">CANCEL UPDATE</button>
                      </>

                      :
                      <>
                        <button onClick={() => { resetPatientAdd(); setAddMode(true) }} className="btn btn-sm  btn-success me-1 my-1 " type="button">NEW</button>
                        <button onClick={() => { resetSearchPatient(); setIsSearchPatientModalOpen(true); setAdvanceSearchResults(null); setSearchResults() }} className="btn btn-sm btn-warning me-1 my-1 " type="button">ASSIGN EXISTING</button>
                        {(work_order?.patient_id > 0) &&
                          <>
                            <button onClick={() => setEditMode(true)} className="btn btn-sm    btn-danger me-1 my-1 " type="button">EDIT</button>
                            <button onClick={() => togglePatientMask()} className="btn btn-sm btn-info me-1 my-1 " type="button">{patientMask ? "UN-MASK" : "MASK"} </button>
                          </>
                        }
                      </>
                    }
                  </>
                }







              </div>
            }
          </div>

          {is_loading ?
            <div className="text-center m-auto loader" >
              <ReactLoading type={"cylon"} color={"#54418B"} height={250} width={250} />
            </div>
            :
            <>
              {(work_order?.patient_id > 0 || addMode) ?

                <form id="frm_patient" >


                  {(addMode) ?

                    <>
                      <div className="row px-3 py-2 gx-2 ">

                        <div className="col-4 my-2">
                          <label htmlFor="patient_first_name" >First Name*</label>

                          <InputAuto name="patient_first_name" className="form-control" minStart="3"
                            value={patientAdd.patient_first_name}
                            pholder=""
                            data={patientsFirstNames}
                            field="patient_first_name"
                            onChange={(e) =>
                              setPatientAdd({ ...patientAdd, patient_first_name: e })
                            }
                            onSelected={(e) => {

                              searchPatient(e.patient_first_name, "", "", 10)
                            }
                            }

                          />
                          {inputError &&
                            (!patientAdd.patient_first_name || !(patientAdd.patient_first_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                              <span className="text-danger">Enter valid first name</span>
                            )}




                        </div>
                        <div className="col-4 my-2">
                          <label htmlFor="patient_middle_name">Middle Name</label>

                          <InputAuto name="patient_middle_name" className="form-control" minStart="3"
                            value={patientAdd.patient_middle_name}
                            pholder=""
                            data={patientsMiddleNames}
                            field="patient_middle_name"
                            onChange={(e) =>
                              setPatientAdd({ ...patientAdd, patient_middle_name: e })
                            }
                            onSelected={(e) =>
                              searchPatient("", e.patient_middle_name, "", 10)
                            }

                          />
                          {inputError &&
  patientAdd.patient_middle_name &&
  !patientAdd.patient_middle_name.match(/^[A-Za-z'.\-, ]+$/) && (
    <span className="text-danger">Enter valid middle name</span>
)}


                        </div>
                        <div className="col-4 my-2">
                          <label htmlFor="patient_last_name">Last Name*</label>
                          <InputAuto name="patient_last_name" className="form-control" minStart="3"
                            value={patientAdd.patient_last_name}
                            pholder=""
                            data={patientsLastNames}
                            field="patient_last_name"
                            onChange={(e) =>
                              setPatientAdd({ ...patientAdd, patient_last_name: e })
                            }
                            onSelected={(e) =>
                              searchPatient("", "", e.patient_last_name, 10)
                            }
                          />
                          {inputError &&
                            (!patientAdd.patient_last_name || !(patientAdd.patient_last_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                              <span className="text-danger">Enter valid Last name</span>
                            )}

                        </div>

                        <div className="col-4 my-2">
                          <label htmlFor="patient_dob">Date of Birth*</label>
                          <DatePicker name="patient_dob" id="patient_dob" type="text"
                            className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            onFocus={() => setSearchResults(null)}
                            selected={patientAdd.patient_dob}
                            onKeyDown={(e) => {
                              if (e.keyCode === 9) {
                                e.preventDefault();
                                document.getElementById("patient_ssn_add").focus();
                                document.getElementById("patient_ssn_add").select();
                              }
                            }}
                            onChange={(e) => {
                              var dt = new Date(e);

                              const year = dt.getFullYear();
                              const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                              const day = dt.getDate().toString().padStart(2, "0");

                              const formatted_date = month + '/' + day + '/' + year

                              setPatientAdd({ ...patientAdd, patient_dob: formatted_date })

                            }
                            }
                          />
                          {inputError &&
                            (!patientAdd.patient_dob || !/^\d{2}\/\d{2}\/\d{4}$/.test(patientAdd.patient_dob)) && (
                              <span className="text-danger">Enter valid date of birth</span>
                            )}

                        </div>
                        <div className="col-4 my-2">
                          <label htmlFor="patient_ssn">SSN*</label>

                          <input name="patient_ssn" id="patient_ssn_add" type="text" className="form-control"
                            value={patientAdd.patient_ssn} placeholder="000-00-0000"
                            onFocus={() => setSearchResults(null)}
                            onChange={(e) =>
                              setPatientAdd({ ...patientAdd, patient_ssn: e.target.value })
                            }
                            onKeyUp={(e) => {
                              if (!/^[0-9\s]+$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onKeyPress={(e) => {
                              const s = e.target.selectionStart;
                              e.target.value = e.target.value.slice(0, s) + e.target.value.slice(s + 1);
                              e.target.selectionEnd = s;
                            }}
                          />
                          {inputError &&
                            (!patientAdd.patient_ssn || !/^\d{3}-\d{2}-\d{4}$/.test(patientAdd.patient_ssn)) && (
                              <span className="text-danger">Enter a valid SSN</span>
                            )}

                        </div>
                        <div className="col-4 my-2">
                          <label htmlFor="patient_med_rec_num">Medical Record #</label>

                          <input name="patient_med_rec_num" id="patient_med_rec_num" type="text"
                            className="form-control" onFocus={() => setSearchResults(null)}
                            value={patientAdd.patient_med_rec_num} onChange={(e) =>
                              setPatientAdd({ ...patientAdd, patient_med_rec_num: e.target.value })
                            }
                          />

                        </div>



                       
                          <div className="col-4 my-2">

                            <label htmlFor="patient_address" >ADDRESS</label>

                            <input name="patient_address" id="patient_address" type="text" className="form-control"
                              value={patientAdd.patient_address} onChange={(e) =>
                                setPatientAdd({ ...patientAdd, patient_address: e.target.value })
                              }
                            />
                          </div>
                          <div className="col-4 my-2">
                            <label htmlFor="patient_phone_number">PHONE NUMBER</label>

                            <input name="patient_phone_number" id="patient_phone_number" type="text" className="form-control"
                              value={patientAdd.patient_phone_number} onChange={(e) =>
                                setPatientAdd({ ...patientAdd, patient_phone_number: e.target.value })
                              }

                            />
                            {inputError &&
                              (!validatePhone(patientAdd.patient_phone_number)) && (
                                <span className="text-danger">Enter a valid phone number</span>
                              )}


                          </div>
                          <div className="col-4 my-2">
                            <label htmlFor="patient_email">EMAIL</label>

                            <input name="patient_email" id="patient_email" type="text" className="form-control"
                              value={patientAdd.patient_email} onChange={(e) =>
                                setPatientAdd({ ...patientAdd, patient_email: e.target.value })
                              }
                            />
                            {inputError &&
                              (!validateEmail(patientAdd.patient_email)) && (
                                <span className="text-danger">Enter a valid email</span>
                              )}



                          </div>
                       
                      </div>

                    </>
                    :
                    <>


                      {(editMode) ?

                        <>
                          <div className="row px-3 py-2 gx-2 ">

                            <div className="col-4 my-2">
                              <label htmlFor="patient_first_name" >First Name*</label>

                              <InputAuto name="patient_first_name" className="form-control" minStart="3"
                                value={patient.patient_first_name}
                                pholder=""
                                data={patientsFirstNames}
                                field="patient_first_name"
                                onChange={(e) =>
                                  setPatient({ ...patient, patient_first_name: e })
                                }
                                onSelected={(e) => {

                                  searchPatient(e.patient_first_name, "", "", 10)
                                }
                                }

                              />
                              {inputError &&
                                (!patient.patient_first_name || !(patient.patient_first_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                  <span className="text-danger">Enter valid first name</span>
                                )}




                            </div>
                            <div className="col-4 my-2">
                              <label htmlFor="patient_middle_name">Middle Name</label>

                              <InputAuto name="patient_middle_name" className="form-control" minStart="3"
                                value={patient.patient_middle_name}
                                pholder=""
                                data={patientsMiddleNames}
                                field="patient_middle_name"
                                onChange={(e) =>
                                  setPatient({ ...patient, patient_middle_name: e })
                                }
                                onSelected={(e) =>
                                  searchPatient("", e.patient_middle_name, "", 10)
                                }

                              />
                             {inputError &&
  patient.patient_middle_name && // only validate if not empty
  !patient.patient_middle_name.match(/^[A-Za-z'.\-, ]+$/) && (
    <span className="text-danger">Enter valid middle name</span>
)}


                            </div>
                            <div className="col-4 my-2">
                              <label htmlFor="patient_last_name">Last Name*</label>
                              <InputAuto name="patient_last_name" className="form-control" minStart="3"
                                value={patient.patient_last_name}
                                pholder=""
                                data={patientsLastNames}
                                field="patient_last_name"
                                onChange={(e) =>
                                  setPatient({ ...patient, patient_last_name: e })
                                }
                                onSelected={(e) =>
                                  searchPatient("", "", e.patient_last_name, 10)
                                }
                              />
                              {inputError &&
                                (!patient.patient_last_name || !(patient.patient_last_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                  <span className="text-danger">Enter valid Last name</span>
                                )}

                            </div>

                            <div className="col-4 my-2">
                              <label htmlFor="patient_dob">Date of Birth*</label>
                              <DatePicker name="patient_dob" id="patient_dob" type="text"
                                className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                onFocus={() => setSearchResults(null)}
                                selected={patient.patient_dob}
                                onKeyDown={(e) => {
                                  if (e.keyCode === 9) {
                                    e.preventDefault();
                                    document.getElementById("patient_ssn_edit").focus();
                                    document.getElementById("patient_ssn_add").select();
                                  }
                                }}
                                onChange={(e) => {
                                  var dt = new Date(e);

                                  const year = dt.getFullYear();
                                  const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                  const day = dt.getDate().toString().padStart(2, "0");

                                  const formatted_date = month + '/' + day + '/' + year

                                  setPatient({ ...patient, patient_dob: formatted_date })

                                }
                                }
                              />
                              {inputError &&
                                (!patient.patient_dob || !/^\d{2}\/\d{2}\/\d{4}$/.test(patient.patient_dob)) && (
                                  <span className="text-danger">Enter valid date of birth</span>
                                )}

                            </div>
                            <div className="col-4 my-2">
                              <label htmlFor="patient_ssn">SSN*</label>

                              <input name="patient_ssn" id="patient_ssn_edit" type="text" className="form-control"
                                value={patient.patient_ssn} placeholder="000-00-0000"
                                onFocus={() => setSearchResults(null)}
                                onChange={(e) =>
                                  setPatient({ ...patient, patient_ssn: e.target.value })
                                }
                                onKeyUp={(e) => {
                                  if (!/^[0-9\s]+$/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onKeyPress={(e) => {
                                  const s = e.target.selectionStart;
                                  e.target.value = e.target.value.slice(0, s) + e.target.value.slice(s + 1);
                                  e.target.selectionEnd = s;
                                }}
                              />
                              {inputError &&
                                (!patient.patient_ssn || !/^\d{3}-\d{2}-\d{4}$/.test(patient.patient_ssn)) && (
                                  <span className="text-danger">Enter a valid SSN</span>
                                )}

                            </div>
                            <div className="col-4 my-2">
                              <label htmlFor="patient_med_rec_num">Medical Record #</label>

                              <input name="patient_med_rec_num" id="patient_med_rec_num" type="text"
                                className="form-control" onFocus={() => setSearchResults(null)}
                                value={patient.patient_med_rec_num} onChange={(e) =>
                                  setPatient({ ...patient, patient_med_rec_num: e.target.value })
                                }
                              />

                            </div>




                          
                              <div className="col-4 my-2">

                                <label htmlFor="patient_address" >ADDRESS</label>

                                <input name="patient_address" id="patient_address" type="text" className="form-control"
                                  value={patient.patient_address} onChange={(e) =>
                                    setPatient({ ...patient, patient_address: e.target.value })
                                  }
                                />
                              </div>
                              <div className="col-4 my-2">
                                <label htmlFor="patient_phone_number">PHONE NUMBER</label>

                                <input name="patient_phone_number" id="patient_phone_number" type="text" className="form-control"
                                  value={patient.patient_phone_number} onChange={(e) =>
                                    setPatient({ ...patient, patient_phone_number: e.target.value })
                                  }

                                />
                                {inputError &&
                                  (!validatePhone(patient.patient_phone_number)) && (
                                    <span className="text-danger">Enter a valid phone number</span>
                                  )}


                              </div>
                              <div className="col-4 my-2">
                                <label htmlFor="patient_email">EMAIL</label>

                                <input name="patient_email" id="patient_email" type="text" className="form-control"
                                  value={patient.patient_email} onChange={(e) =>
                                    setPatient({ ...patient, patient_email: e.target.value })
                                  }
                                />
                                {inputError &&
                                  (!validateEmail(patient.patient_email)) && (
                                    <span className="text-danger">Enter a valid email</span>
                                  )}



                              </div>
                          

                          </div>

                        </>
                        :

                        <>
                          <div className="row px-3 py-2 gx-2 ">

                            <div className="col-4 my-2">
                              <label htmlFor="patient_first_name" >First Name</label><br />
                              <label className="field-info">{patient.patient_first_name}</label>


                            </div>
                            <div className="col-4 my-2">
                              <label htmlFor="patient_middle_name">Middle Name</label><br />
                              <label className="field-info">{patient.patient_middle_name}</label>
                            </div>
                            <div className="col-4 my-2">
                              <label htmlFor="patient_last_name">Last Name</label><br />
                              <label className="field-info">{patient.patient_last_name}</label>

                            </div>

                            <div className="col-4 my-2">
                              <label htmlFor="patient_dob">Date of Birth</label><br />
                              <label className="field-info">{patient.patient_dob}</label>

                            </div>
                            <div className="col-4 my-2">
                              <label htmlFor="patient_ssn">SSN</label><br />

                              {patientMask ?
                                <label className="field-info">***-**-{patient.patient_ssn.substring(patient.patient_ssn.length - 4)}</label>
                                :
                                <label className="field-info">{patient.patient_ssn}</label>
                              }

                            </div>
                            <div className="col-4 my-2">
                              <label htmlFor="patient_med_rec_num">Medical Record #</label><br />
                              <label className="field-info">{patient.patient_med_rec_num ? patient.patient_med_rec_num : ""}</label>


                            </div>



                            <div className="col-4 my-2">

                              <label htmlFor="patient_address" >ADDRESS</label><br />
                              {patientMask ?
                                <label className="field-info">******</label>
                                :
                                <label className="field-info">{patient.patient_address ? patient.patient_address : ""}</label>

                              }



                            </div>
                            <div className="col-4 my-2">
                              <label htmlFor="patient_phone_number">PHONE NUMBER</label><br />


                              {patientMask ?
                                <label className="field-info">******</label>
                                :
                                <label className="field-info">{patient.patient_phone_number ? patient.patient_phone_number : ""}</label>

                              }


                            </div>
                            <div className="col-4 my-2">
                              <label htmlFor="patient_email">EMAIL</label><br />


                              {patientMask ?
                                <label className="field-info">******</label>
                                :
                                <label className="field-info">{patient.patient_email ? patient.patient_email : ""}</label>

                              }


                            </div>


                          </div>

                        </>
                      }
                    </>
                  }


                  <div className="row px-3 pb-3 gx-2 ">
                    <div className="col-xl-12 col-lg-12 col-sm-12 my-0"><hr /></div>
                    <div className="col-6 my-0">



                      {(work_order?.patient_id) &&

                        <>
                          {work_order.wo_patient_authorization ? <>

                            <label >Patient Authorization: <br />{work_order.authorization_status == 1 ? "VALID" : "VOID"}</label>
                            <div className="mt-2">
                              <a className="btn btn-sm btn-sm btn-success ms-1" href={process.env.REACT_APP_WEB_SERVICES_URL + "/admin/download-patient-authorization/" + work_order.work_order_id} target="_blank" >Download</a>
                              <a className="btn btn-sm btn-sm btn-warning ms-1" href="javascript:void(0)" onClick={removeAuthorization} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1 my-1" role="status"></div><span className="sr-only">Loading...</span></> : "DELETE"}</a>
                              {(work_order?.status < 4 && work_order.authorization_status == 1) &&
                                <a className="btn btn-sm btn-sm btn-danger ms-1 " href="javascript:void(0)" onClick={invalidateAuthorization} >Void</a>

                              }
                              {(work_order.authorization_status != 1) &&
                                <a className="btn btn-sm btn-sm btn-danger ms-1 " href="javascript:void(0)" onClick={validateAuthorization} >Validate</a>
                              }

                            </div>
                          </>
                            :
                            <>
                              <label >Patient Authorization:<br /><span className=" fw-bolder text-danger">VALID AUTHORIZATION NEEDED</span></label>
                              {work_order?.status < 7 &&

                                <div className="input-group w-auto mt-2">
                                  <input name="wo_patient_authorization" id="wo_patient_authorization" type="file" className="form-control"
                                    accept="pdf/*" onChange={(e) =>
                                      setWOPatientAuthorization(e.target.files[0])}

                                  />
                                  <a className="btn btn-sm btn-success ms-1" href="javascript:void(0)" onClick={(e) =>
                                    addWOPatientAuthorizationToWorkOrder(work_order.work_order_id, 1)} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1 my-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPLOAD"} </a>
                                </div>
                              }
                            </>
                          }
                        </>
                      }
                    </div>

                    <div className="col-6 my-0">


                      {(work_order?.patient_id) &&

                        <>
                          {work_order.wo_patient_special_authorization ?
                            <>
                              <label>Special Authorization:<br /> VALID</label>
                              <div className="mt-2">
                                <a className="btn btn-sm btn-sm btn-success ms-1" href={process.env.REACT_APP_WEB_SERVICES_URL + "/admin/download-patient-special-authorization/" + work_order.work_order_id} target="_blank" >Download</a>
                                <a className="btn btn-sm btn-sm btn-warning ms-1" href="javascript:void(0)" onClick={removeSpecialAuthorization} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1 my-1" role="status"></div><span className="sr-only">Loading...</span></> : "DELETE"}</a>

                              </div>
                            </>
                            :
                            <>
                              <label>Special Authorization:<br />&nbsp; </label>
                              {work_order?.status < 7 &&

                                <div className="input-group w-auto mt-2">
                                  <input name="wo_patient_special_authorization" id="wo_patient_special_authorization" type="file" className="form-control"
                                    accept="pdf/*" onChange={(e) =>
                                      setWOPatientSpecialAuthorization(e.target.files[0])}

                                  />
                                  <a className="btn btn-sm  btn-success ms-1" href="javascript:void(0)" onClick={(e) =>
                                    addWOPatientAuthorizationToWorkOrder(work_order.work_order_id, 2)} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1 my-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPLOAD"}</a>

                                </div>
                              }
                            </>
                          }
                        </>
                      }
                    </div>

                  </div>










                  {(searchResults && searchResults != "" && searchResults != null) &&
                    <>
                      <div className="row mt-2">
                        <div className="col-12">
                          <div className="sub-heading px-3 py-2 fw-bold text-dark">These records already exists in our database. Click on the link to add </div>

                        </div>
                      </div>


                      <div className="row">
                        <div className="col-12 pb-3 ps-4">
                          {searchResults}
                        </div>
                      </div>
                    </>
                  }



                </form>
                :
                <div className="row " >

                  <div className="col-xl-12 col-lg-12 p-5" >

                    <h5>To begin creating a new case, please add a new or an existing patient..</h5>

                  </div>

                </div>
              }
            </>


          }
        </div>



      </div>







      <Modal animation={false}
        show={isSearchPatientModalOpen}
        onHide={() => { setIsSearchPatientModalOpen(false); }}
        keyboard={false}
        backdrop="static"
        id="search-patient-modal"
        size="xl"
      >
        <Modal.Header><h3 className="m-0 p-0">ADVANCE SEARCH</h3></Modal.Header>
        <Modal.Body>
          <div className="modal-inner-content ">

            <form className="form-horizontal form-thick"  >


              <div className="row pb-4">

                <div className="col-3 my-2">
                  <label htmlFor="patient_first_name" >First Name</label>
                  <InputAuto name="patient_first_name" className="form-control" minStart="3"
                    value={patientSearch.patient_first_name}
                    pholder=""
                    data={patientsFirstNames}
                    field="patient_first_name"
                    onChange={(e) =>
                      setPatientSearch({ ...patientSearch, patient_first_name: e })
                    }
                    onSelected={(e) =>
                      advanceSearchPatient(e.patient_first_name)
                    }

                  />


                </div>
                <div className="col-3 my-2">
                  <label htmlFor="patient_middle_name">Middle Name</label>
                  <InputAuto name="patient_middle_name" className="form-control" minStart="3"
                    value={patientSearch.patient_middle_name}
                    pholder=""
                    data={patientsMiddleNames}
                    field="patient_middle_name"
                    onChange={(e) =>
                      setPatientSearch({ ...patientSearch, patient_middle_name: e })
                    }
                    onSelected={(e) =>
                      advanceSearchPatient("", e.patient_middle_name)
                    }

                  />
                </div>
                <div className="col-3 my-2">
                  <label htmlFor="patient_last_name">Last Name</label>
                  <InputAuto name="patient_last_name" className="form-control" minStart="3"
                    value={patientSearch.patient_last_name}
                    pholder=""
                    data={patientsLastNames}
                    field="patient_last_name"
                    onChange={(e) =>
                      setPatientSearch({ ...patientSearch, patient_last_name: e })
                    }
                    onSelected={(e) =>
                      advanceSearchPatient(e.patient_last_name)
                    }

                  />



                </div>



                <div className="col-3 my-2">
                  <label htmlFor="patient_dob">Date of Birth</label>
                  <DatePicker name="patient_dob" id="patient_dob" type="text"
                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={patientSearch.patient_dob}
                    onKeyDown={(e) => {
                      if (e.keyCode === 9) {
                        e.preventDefault();
                        document.getElementById("patient_ssn").focus();
                        document.getElementById("patient_ssn_add").select();
                      }
                    }}
                    onChange={(e) =>
                      setPatientSearch({ ...patientSearch, patient_dob: e })
                    }
                  />

                </div>
                <div className="col-3 my-2">
                  <label htmlFor="patient_ssn">SSN</label>
                  <input name="patient_ssn" id="patient_ssn" type="text" className="form-control"
                    value={patientSearch.patient_ssn} placeholder="000-00-0000"
                    onChange={(e) =>
                      setPatientSearch({ ...patientSearch, patient_ssn: e.target.value })
                    }
                    onKeyPress={(e) => {
                      const s = e.target.selectionStart;
                      e.target.value = e.target.value.slice(0, s) + e.target.value.slice(s + 1);
                      e.target.selectionEnd = s;
                    }}
                  />

                </div>
                <div className="col-3 my-2">
                  <label htmlFor="patient_med_rec_num">Medical Record #</label>
                  <input name="patient_med_rec_num" id="patient_med_rec_num" type="text" className="form-control"
                    value={patientSearch.patient_med_rec_num}
                    onChange={(e) =>
                      setPatientSearch({ ...patientSearch, patient_med_rec_num: e.target.value })
                    }

                  />

                </div>



                <div className="col-3 my-2">
                  <label htmlFor="client_company_name">Client/Company Name</label>
                  <input name="client_company_name" id="client_company_name" type="text" className="form-control"
                    value={patientSearch.client_company_name} onChange={(e) =>
                      setPatientSearch({ ...patientSearch, client_company_name: e.target.value })
                    }
                  />

                </div>
                <div className="col-3 my-2">
                  <label htmlFor="facility_name">Facility Name</label>
                  <input name="facility_name" id="facility_name" type="text" className="form-control"
                    value={patientSearch.facility_name} onChange={(e) =>
                      setPatientSearch({ ...patientSearch, facility_name: e.target.value })
                    }
                  />

                </div>
                <div className="col-3 my-2">
                  <label htmlFor="wo_policy_number">Claim/Policy Number</label>
                  <input name="wo_policy_number" id="wo_policy_number" type="text" className="form-control"
                    value={patientSearch.wo_policy_number} onChange={(e) =>
                      setPatientSearch({ ...patientSearch, wo_policy_number: e.target.value })
                    }

                  />

                </div>

              </div>







              <div className="modal-footer text-center m-auto">
                <button type='button' onClick={() => advanceSearchPatient()} className="btn btn-sm btn-lg btn-success" disabled={isBtn}>
                  {isBtn ? <><div className="spinner-border spinner-border-sm me-1 my-1" role="status"></div><span className="sr-only">Loading...</span></> : 'Search'}
                </button>
                <button type='button' className="btn btn-sm btn-lg btn-warning" onClick={(e) => setIsSearchPatientModalOpen(false)}  >Cancel</button>
                <button className="btn btn-sm btn-danger" onClick={() => { resetPatientAdd(); setAddMode(true); setIsSearchPatientModalOpen(false); }}>New</button>

              </div>
              {advanceSearchResults &&
                <>
                  <div className="row">
                    <div className="col-12 p-3 ps-4">

                      <b>These records already exists in our database. Click on the link to add</b>


                      {advanceSearchResults}
                    </div>
                  </div>
                </>

              }
            </form>
          </div>
        </Modal.Body>
      </Modal>





    </>

  );
};

export default PatientInformation;